import React, { useState } from 'react';
import Autocomplete from 'react-google-autocomplete';

const PlacesWithStandaloneSearchBox = ({ location, handleChange, value }) => {
  const [street, updateStreet] = useState(value ? JSON.parse(value).street : '');

  const handleStreet = (e) => {
    updateStreet(e.target.value);
  };
  return (
    <>
      <Autocomplete
        ref={location}
        className="form-control"
        id="autocomplete"
        value={street}
        style={{
          boxSizing: `border-box`,
          border: `1px solid transparent`,
          width: `100%`,
          height: `50px`,
          padding: `0 12px`,
          borderRadius: `3px`,
          boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
          fontSize: `14px`,
          outline: `none`,
          zIndex: '10000'
        }}
        onChange={handleStreet}
        onPlaceSelected={(place) => {
          if (place && place.geometry && place.geometry.location) {
            const latValue = place.geometry.location.lat().toString();
            const lngValue = place.geometry.location.lng().toString();
            var address = {}
            updateStreet(place.formatted_address);
            address.street = place.formatted_address
            address.latitude = latValue
            address.longitude = lngValue
            let matches = place?.address_components?.filter(
              (address_component) => {
                return ['colloquial_area', 'locality'].some(
                  (word) => ~address_component.types.indexOf(word)
                );
              }
            );
            updateStreet(place.formatted_address);
            if (matches.length) {
              address.city = matches[0].long_name
            }
            for (var i = 0; i < place.address_components.length; i++) {
              for (var j = 0; j < place.address_components[i].types.length; j++) {
                if (place.address_components[i].types[j] === 'postal_code') {
                  const pincode = place.address_components[i].long_name;
                  address.pincode = pincode
                }
                if (
                  place.address_components[i].types[j] ===
                  'administrative_area_level_1'
                ) {
                  const state = place.address_components[i].long_name;
                  address.state = state
                }
                if (place.address_components[i].types[j] === 'country') {
                  const country = place.address_components[i].long_name;
                  address.country = country
                }
              }
            }
            handleChange({ latitude: latValue, longitude: lngValue }, address)
          }
        }}
        types={[]}
        componentRestrictions={{ country: 'au' }}
      />
    </>
  );
};
export default PlacesWithStandaloneSearchBox;
